import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { singletonHook } from 'react-singleton-hook';

import { IInquiryStatus } from '@interfaces/lookups';
import { userDataSelector } from '@store/features/auth/user/selectors';
import { handleGetInquiryStatuses } from '@store/features/inquiryStatuses/actions';
import {
  inquiryStatusesErrorSelector,
  inquiryStatusesIsLoadingSelector,
  inquiryStatusesIsReadySelector,
  inquiryStatusesSelector,
} from '@store/features/inquiryStatuses/selectors';
import useDispatch from '@store/hooks/useDispatch';

import useFetchLookupData from './useFetchLookupData';

const useInquiryStatuses = (): IInquiryStatus[] => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(inquiryStatusesSelector);
  const isLoading = useSelector(inquiryStatusesIsLoadingSelector);
  const isReady = useSelector(inquiryStatusesIsReadySelector);
  const error = useSelector(inquiryStatusesErrorSelector);
  const user = useSelector(userDataSelector);

  const handleFetch = useCallback(() => {
    user?.organizationId && dispatch(handleGetInquiryStatuses());
  }, [dispatch, user]);

  useFetchLookupData({
    isReady,
    isLoading,
    error: error && t('errors.inquiryStatusesError'),
    handleFetch,
  });

  return data;
};

export default singletonHook([], useInquiryStatuses);
